/**
 * Which blocked-microphone instructions to show.
 *
 * The desktop app is a Tauri webview whose user agent looks like Safari, so
 * desktop is checked before the browser. Chrome and Edge share the address-bar
 * lock; everything else gets a generic line.
 */
export type TMicHelpEnvironment = "desktop" | "safari" | "chromium" | "generic"

export function micHelpEnvironment(input: { isDesktop: boolean; userAgent: string }): TMicHelpEnvironment {
  if (input.isDesktop) return "desktop"
  const ua = input.userAgent
  if (/Edg\//i.test(ua) || /Chrome\//i.test(ua)) return "chromium"
  if (/Safari\//i.test(ua)) return "safari"
  return "generic"
}
